import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  connect() {
    M.Dropdown.init(this.element, this.options);
  }

  get options() {
    return {
      coverTrigger: false,
      inDuration: 0,
      outDuration: 0
    };
  }
}
